import React from "react";
import ComingSoon from "../../Shared/ComingSoon/ComingSoon";

const Blog = () => {
  return (
    <div>
      <ComingSoon></ComingSoon>
    </div>
  );
};

export default Blog;
